import { createContext } from "react";

const CatDiagnosticosContext = createContext();

export default CatDiagnosticosContext;
